// "Show advanced" - who sees diagnostic detail on the Options screens.
//   admins (broker.enable_live)      on by default (they can switch it off for themselves)
//   everyone else                    off by default; an experienced trader can switch it on
// Stored per user in this browser. It only decides what is SHOWN; every check still runs.
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { P } from "@/lib/permissions";

const EVENT = "gz-advanced-changed";
const key = (uid) => `gz.options.showAdvanced.${uid || "anon"}`;

function read(user) {
  try {
    const v = window.localStorage.getItem(key(user?.id));
    if (v === "1") return true;
    if (v === "0") return false;
  } catch (e) { /* storage unavailable: fall back to the role default */ }
  return (user?.permissions || []).includes(P.BROKER_LIVE_ADMIN);
}

export function useAdvanced() {
  const auth = useAuth();
  const user = auth?.user;
  const [on, setOn] = useState(() => read(user));
  useEffect(() => {
    setOn(read(user));
    const h = () => setOn(read(user));
    window.addEventListener(EVENT, h);
    return () => window.removeEventListener(EVENT, h);
  }, [user]);
  const set = useCallback((v) => {
    try { window.localStorage.setItem(key(user?.id), v ? "1" : "0"); } catch (e) { /* ignore */ }
    window.dispatchEvent(new Event(EVENT));
  }, [user]);
  return [on, set];
}
